import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter as Router } from "react-router-dom";
import { canonicalHref } from './config/deploy.js';

// Boot the SDK only on the licensed host. www fails the domain check and the
// wasm assembly is dropped before the camera mirror opens.
const licensedHref = canonicalHref(window.location.href)
if (licensedHref) {
  window.location.replace(licensedHref)
} else {
  const root = ReactDOM.createRoot(document.getElementById('root'));
  root.render(
    <Router>
      <React.StrictMode>
        <App />
      </React.StrictMode>
    </Router>
  );
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
